import React from 'react';
import { useMoney } from "../../../hooks/useMoney";
import { ArrowLeft } from 'lucide-react';

interface PrincipalTopUpHeaderProps {
  principalName: string;
  onBack: () => void;
  bankBalance: string;
  bankBalanceLoading: boolean;
  walletBalance: string;
  walletBalanceLoading: boolean;
  saralAmount: string;
  onOpenStatements: () => void;
  onAddTopUp: () => void;
}

const PrincipalTopUpHeader: React.FC<PrincipalTopUpHeaderProps> = ({
  principalName,
  onBack,
  bankBalance,
  bankBalanceLoading,
  walletBalance,
  walletBalanceLoading,
  saralAmount,
  onOpenStatements,
  onAddTopUp,
}) => {
  const { symbol } = useMoney();
  return (
    <div className="flex border-b border-cardborder mb-8 flex-col md:flex-row md:items-center md:justify-between max-w-7xl mx-auto px-7 py-8">
      <div className="flex items-start gap-3">
        <button
          onClick={onBack}
          className="p-1.5 hover:bg-gray-100 rounded-full transition-colors mt-1"
          aria-label="Go back"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-8">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Top Up Wallet</h1>
            <div className="text-sm text-gray-500 mt-1">{principalName}</div>
          </div>
          <div className="flex flex-wrap gap-6">
            <div>
              <p className="text-xs text-gray-500">Bank Balance</p>
              <p className="text-lg font-semibold text-gray-900 mt-0.5">
                {bankBalanceLoading ? 'Loading...' : `${symbol}${bankBalance}`}
              </p>
            </div>
            <div>
              <p className="text-xs text-gray-500">Wallet Balance</p>
              <p className="text-lg font-semibold text-gray-900 mt-0.5">
                {walletBalanceLoading ? 'Loading...' : `${symbol}${walletBalance}`}
              </p>
            </div>
            <div>
              <p className="text-xs text-gray-500">Saral Amount</p>
              <p className="text-lg font-semibold text-gray-900 mt-0.5">{symbol}{saralAmount}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex gap-3 mt-4 md:mt-0 md:ml-4 flex-wrap">
        <button
          onClick={onOpenStatements}
          className="px-4 py-2 text-sm font-medium text-white bg-brand rounded-md hover:bg-brand/80 focus:outline-none"
        >
          Statements
        </button>
        <button
          onClick={onAddTopUp}
          className="px-4 py-2 text-sm font-medium text-white bg-brand rounded-md hover:bg-brand/80 focus:outline-none"
        >
          Add Top-Up
        </button>
      </div>
    </div>
  );
};

export default PrincipalTopUpHeader;
